<template>
    <div class="contaner-slider full-height ">
        <b-carousel
                id="carousel-1"
                v-model="slide"
                :interval="4000"
                controls
                loop="true"
                indicators
                background="#ababab"
                img-width="100%"
                img-height="480"
                style="height: 100%;background: transparent"
                @sliding-start="onSlideStart"
                @sliding-end="onSlideEnd"
        >
            <!--         WELCOME SLIDE -->
            <b-carousel-slide class="slide-home">
                <template v-slot:img>
                    <div id="principal-img" class="container-fluid">

                        <div class="welcome">
                            <h4 class="animated bounceInDown">{{$t('welcome')}}</h4>
                            <h2 class="animated zoomIn">DTT Coaching Services, LLC</h2>
                            <h5 class="animated bounceInUp" v-html="$t('welcome1')"></h5>
                        </div>

                        <img class="img-fluid img-bg animated bounceInUp" src="../assets/img/v2/slides/home.png" alt="">
<!--                        <img class="img-fluid elements animated fadeInRight" data-wow-delay="0.5s"-->
<!--                             src="../assets/img/bg-dttcs.png" alt="">-->
                    </div>
                </template>
            </b-carousel-slide>
            <!-- Slides with img slot -->
            <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
            <b-carousel-slide>
                <template v-slot:img>
                    <!--                    v-if="active == 0"-->
                    <div class="animated  slider-tip tip1">
                        <h2 class="animated slideInDown ">{{$t('news.slides.noty1')}}</h2>
                        <a href="tel:+17867012401" class=" animated bounceIn  btn btn-common mt-3 out-line"><i
                                data-v-71f682d5="" class="lni-phone-handset"></i>{{$t('news.slides.btn1')}}</a>
                    </div>
                    <img class="img-slide-present img1 d-none d-md-block" src="../assets/img/v2/cloud-word.svg" alt="">
                    <img
                            class="d-block img-slide w-100"
                            width="1024"
                            height="480"
                            src="../assets/img/v2/slides/1.jpg"
                            alt="image slot"
                    >
                </template>
            </b-carousel-slide>

            <!-- Slides with img slot -->
            <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
            <b-carousel-slide>
                <template v-slot:img>
                    <div class="animated  slider-tip tip2">
                        <h2 class="animated slideInLeft  ">{{$t('news.slides.noty3')}}</h2>
                        <!--                        <a href="tel:+17867012401" class=" animated bounceIn  btn btn-common mt-3 out-line"><i data-v-71f682d5="" class="lni-phone-handset"></i>{{$t('news.slides.btn1')}}</a>-->
                    </div>
                    <img
                            class="d-block img-slide w-100"
                            width="1024"
                            height="480"
                            src="../assets/img/v2/slides/2.jpg"
                            alt="image slot"
                    >
                </template>
            </b-carousel-slide>

            <!-- Slides with img slot -->
            <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
            <b-carousel-slide class="slide3">
                <template v-slot:img>
                    <div class="animated  slider-tip tip3">
                        <h2 class="animated slideInRight ">{{$t('news.slides.noty2')}}</h2>

                    </div>
                    <img class="img-slide-present img3" src="../assets/img/v2/psychotherapy-concept.svg" alt="">
                    <!--                    <img-->
                    <!--                            class="d-block img-slide w-100"-->
                    <!--                            width="1024"-->
                    <!--                            height="480"-->
                    <!--                            src="../assets/img/slide/home-bg4.jpg"-->
                    <!--                            alt="image slot">-->
                </template>
            </b-carousel-slide>

            <!-- Slides with img slot -->
            <!-- NOTICIAS -->
            <b-carousel-slide class="slide4">
                <template v-slot:img>
                    <div class="slide-container">
                        <div class=" container-fluid full-height">
                            <div class="row full-height">
                                <div class="col-md-8 col-12 noty-container center">
                                    <div class="row">
                                        <template  v-for="(item, index) in listNews">
                                            <div v-if="index <4"
                                                    class="animated bounceIn  col-md-6">
                                                <div class="noty-item">
                                                    <div class="noty-img">
                                                        <img class="img-fluid"
                                                             v-bind:src="'../assets/data/news/images/'+item[activeLang].poster+'.jpg'"
                                                             alt="">
                                                    </div>
                                                    <div class="contetn text-left">
                                                        <div class="info-text">
                                                            <h3><a href="#">{{item[activeLang].title}}</a></h3>
                                                        </div>
                                                        <template v-for="(txt, i) in item[activeLang].texts">
                                                            <p v-if="i === 0" class="text-infinity-2">{{txt}}</p>
                                                        </template>
<!--                                                        v-bind:to="'/news/#notice'+index"-->
                                                        <router-link to="/news/" class="nav-link btn-see">{{$t('readMore')}}
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>


                                    </div>

                                </div>
                                <div class="col-md-4 animated  slider-tip tip4 d-none d-md-block d-lg-block">
                                    <h2 class="animated slideInRight ">{{$t('news.slides.noty4')}}</h2>
                                </div>
                            </div>
                        </div>
                    </div>


                </template>
            </b-carousel-slide>

        </b-carousel>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        name: "SliderCmp",
        data() {
            return {
                slide: 0,
                sliding: null,
                active: 0,
                listNews: this.$store.getters.news,
                activeLang: this.$store.getters.lang
            }
        },
        created: function () {
            // console.log('NOTICIAS -> ',this.$store.getters.news);
        },
        computed: mapState(['news', 'lang']),
        watch: {
            news(newValue, oldValue) {
                console.log(`Updating from `, oldValue);
                console.log(`To Value `, newValue);
                this.listNews = newValue;

            }, lang(newValue, oldValue) {
                console.log(`CHANGE LANG `, newValue);
                this.activeLang = newValue;

            },
        },
        methods: {
            onSlideStart(slideActive) {
                // setInterval(() => {
                this.active = slideActive;
                // }, 600);

            },
            onSlideEnd() {
            }
        }
    }
</script>

<style lang="scss">
    .carousel-item {
        position: relative;
    }

    .carousel-indicators li {
        background-color: #9cd9f6 !important;
    }

    .carousel-item {
        background: transparent !important;
        position: absolute;
        &.slide-home{
            background-image: linear-gradient(0deg, #d8eafc 0%, #fefefe 100%) !important;
        }

        &.slide3 {
            background-image: linear-gradient(62deg, #f7dee4 0%, #3dafe4 100%) !important;
        }

        &.slide4 {
            background-image: linear-gradient(90deg, #cbf5ff 35%, #0095d9 95%) !important;

            .slide-container {
                display: flex;
                height: 100%;
                width: 100%;
                align-items: center;
            }

            .noty-item {
                background: white;
            }

            .tip4 h2 {

                text-align: center;
                width: 80%;
            }
        }
    }

    .carousel-inner, .carousel-item, .img-slide {
        height: 100% !important;
        background: transparent !important;
    }

    .carousel-control-prev, .carousel-control-next {
        z-index: 999 !important;
    }

</style>
